// extracted by mini-css-extract-plugin
module.exports = {"siteTitle":"style-module--siteTitle--vEB1q","siteTitleText":"style-module--siteTitleText--38Ufo"};